import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getInfoSelectedCandidateStart,
  getInfoSelectedCandidateSuccess,
  getInfoSelectedCandidateFailed,
} from "../redux/getInfoSelectedCandidate";
import { getInfoSelectedCandidateApi } from "core/http/service/evaluation";

function* getSelectedCandidateWork(
  action: ReturnType<typeof getInfoSelectedCandidateStart>
) {
  const payload = action.payload;

  try {
    const res = yield call(getInfoSelectedCandidateApi, payload);
    yield put({
      type: getInfoSelectedCandidateSuccess.type,
      payload: {
        data: res,
      },
    });
  } catch (error: any) {
    yield put({
      type: getInfoSelectedCandidateFailed.type,
    });
  }
}

function* watchGetInfoSelectedCandidate() {
  yield takeLatest(
    getInfoSelectedCandidateStart.type,
    getSelectedCandidateWork
  );
}

export default function* getInfoSelectedCandidateSaga() {
  yield all([watchGetInfoSelectedCandidate()]);
}
